// material
import { Box, Grid, Container, Typography, Button } from '@mui/material';
// components
import Page from '../components/Page';
import {
  AppItemOrders,
  AppWeeklySales,
  AppConversionRates,
  AppWebsiteVisits,
} from '../sections/@dashboard/app';
import { Link } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../context/logincontext';
import Company from './EditCompany'
import { convertNumberStringToInternationalNumberSystem, isAdminRole } from '../utils/helper';
import NetBalance from '../sections/@dashboard/app/NetBalance';
import GenericDashboardCard, { RootStyle } from '../sections/@dashboard/app/GenericDashboardCard';
import { API_URL } from '../constant';
import axios from 'axios';
import moment from 'moment';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const context = useContext(LoginContext)
  const isActive = context?.user?.company?.is_active
  const dealerId = context?.user?.company?.dealer_id
  const [dealerPerformance, setDealerPerformance] = useState({})
  const [thisMonth, setThisMonth] = useState(false)
  const [isLoading, setIsLoading] = useState(false)


  useEffect(() => {
    onToggleMonth(false)
  }, []);

  async function getDealerPerformance(dealerId, date) {
    const res = await axios.get(`${API_URL}/dealers/${dealerId}/performance?date=${date}`);
    const data = res.data?.data?.[0] || {};
    setDealerPerformance(data);
    setIsLoading(false)
  }

  async function onToggleMonth(value) {
    setThisMonth(value)
    setIsLoading(true)
    const date = value ? moment().endOf("month").format("YYYY-MM-DD") : moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
    await getDealerPerformance(dealerId, date)
  }

  return (
    <Page>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2, mt: 1, textAlign: 'center' }}>
          Dashboard
        </Typography>

        <Typography variant="h4" sx={{ mb: 2, mt: 1 }}>
          Loan Overview
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} md={4}>
            <GenericDashboardCard
              title="All Loans"
              fetchUrl={`${API_URL}/dealer_loans/all`}
              filterFunction={(data) => data}
              redirectPath="/dealers/loan_list/all"
              colorKey='error'
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <GenericDashboardCard
              title="Pending Loans"
              fetchUrl={`${API_URL}/dealer_loans/pending_loans`}
              filterFunction={(data) => data}
              redirectPath="/dealers/loan_list/pending_loans"
              colorKey='info'
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <GenericDashboardCard
              title="Disbursed Loans"
              fetchUrl={`${API_URL}/dealer_loans/loan_disbursed`}
              filterFunction={(data) => data}
              colorKey='success'
              redirectPath="/dealers/loan_list/disbursed_loans"
            />
          </Grid>

          {/* Next row */}
          {/* <Grid item xs={12} sm={4} md={4}>
            <GenericDashboardCard
              title="Closed Loans"
              fetchUrl={`${API_URL}/dealer_loans/closed`}
              filterFunction={(data) => data}
              colorKey='error'
              redirectPath="/dealers/loan_list/closed"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <GenericDashboardCard
              title="PDD Loans"
              fetchUrl={`${API_URL}/dealer_loans/loan_disbursed_with_pdd`}
              filterFunction={(data) => data}
              colorKey='info'
              redirectPath="/dealers/loan_list/loan_disbursed_with_pdd"
            />
          </Grid> */}
          <Grid item xs={12} sm={4} md={4}>
            <GenericDashboardCard
              title="Pending Rcs"
              fetchUrl={`${API_URL}/dealers/${dealerId}/missing_rcs_details`}
              filterFunction={(data) => data}
              colorKey='success'
              redirectPath="/dealers/missing_rc"
            />
          </Grid>
        </Grid>

        {/* -------------------- Collection Overview -------------------- */}
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            mt: 4,
            display: "flex",
            alignItems: "center",
            gap:'15px',
            justifyContent: "flex-start",
          }}
        >
          <span>Collection Overview ({thisMonth ? "This Month" : "Last Month"})</span>           
          <LoadingButton
              size="medium"
              type="submit"
              variant="contained"
              onClick={() => onToggleMonth(!thisMonth)}
              loading={isLoading}
            >
              Show {!thisMonth ? 'This' : 'Last'} Month
            </LoadingButton>
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <RootStyle colorKey='info' sx={{
              boxShadow:
                'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
              borderRadius: 2, // optional if you want rounded corners
            }}>
              <div style={{ display: 'flex', flexDirection: 'column', height: '90px' }}>
                <Typography variant="h3">₹ {convertNumberStringToInternationalNumberSystem(dealerPerformance?.total_due_non_mature || '0')}</Typography>
                <Typography variant="subtitle1" sx={{ pt: '15px', pl: '10px' }}>
                  Net Emi Due
                </Typography>
              </div>
            </RootStyle>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <RootStyle colorKey='success' sx={{
              boxShadow:
                'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
              borderRadius: 2, // optional if you want rounded corners
            }}>
              <div style={{ display: 'flex', flexDirection: 'column', height: '90px' }}>
                <Typography variant="h3">₹ {convertNumberStringToInternationalNumberSystem(dealerPerformance?.total_received_non_mature || '0')}</Typography>
                <Typography variant="subtitle1" sx={{ pt: '15px', pl: '10px' }}>
                  Net Emi Paid
                </Typography>
              </div>
            </RootStyle>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <RootStyle colorKey='warning'
              sx={{
                boxShadow:
                  'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
                borderRadius: 2, // optional if you want rounded corners
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', height: '90px' }}>
                <Typography variant="h3">{dealerPerformance.collection_percentage_non_mature} %</Typography>
                <Typography variant="subtitle1" sx={{ pt: '15px', pl: '10px' }}>
                  Total Collection %
                </Typography>
              </div>
            </RootStyle>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={3}>
            <GenericDashboardCard
              title="Repo Stock"
              fetchUrl={`${API_URL}/dealer_loans/repo`}
              filterFunction={(data) => data}
              colorKey='error'
              redirectPath="/dealers/loan_list/repo"

            />
          </Grid> */}
        </Grid>
      </Container>
      {!isActive &&
        <Company />
      }
    </Page>
  );
}
